import React, { useEffect, useState } from 'react';
import podiumService from '../../services/podiumService';
import { SortableTh, useSortableRows } from '../../components/tables/SortableTable';

const COLS = [
  { key: 'name', type: 'string', get: r => r.name },
  { key: 'role_hint', type: 'string', get: r => r.role_hint },
  { key: 'firm', type: 'string', get: r => r.firm || '' },
  { key: 'calls', type: 'number', get: r => r.calls },
  { key: 'fingerprints', type: 'number', get: r => r.fingerprints },
  { key: 'spelling_unverified', type: 'string', get: r => (r.spelling_unverified ? 'unverified' : 'ok') },
];

// People: one row per human, dated affiliations, aliases heard, fingerprints held. Matched on name + a corroborating
// fact (firm, company, voice) — never on name alone; the career view falls out of the affiliations.
export default function PodiumPeoplePanel({ onOpen }) {
  const [rows, setRows] = useState([]);
  useEffect(() => { podiumService.getPeople().then(r => setRows(r.data.people || [])).catch(() => setRows([])); }, []);
  const { sorted, toggle, indicator } = useSortableRows(rows, COLS);
  if (!rows.length) return <p className="text-sm text-gray-500 dark:text-gray-400">No people yet.</p>;
  return (
    <div className="rounded-lg border border-gray-200 p-4 dark:border-gray-800 overflow-x-auto scrollbar-thin">
      <table className="min-w-full text-sm">
        <thead>
          <tr className="text-[11px] uppercase tracking-[0.15em] text-gray-400">
            <SortableTh label="Name" colKey="name" toggle={toggle} indicator={indicator} align="left" />
            <SortableTh label="Role" colKey="role_hint" toggle={toggle} indicator={indicator} align="left" />
            <SortableTh label="Firm" colKey="firm" toggle={toggle} indicator={indicator} align="left" />
            <th className="text-left text-[11px] uppercase tracking-[0.15em] text-gray-400 py-1 pr-3">Affiliations</th>
            <th className="text-left text-[11px] uppercase tracking-[0.15em] text-gray-400 py-1 pr-3">Heard as</th>
            <SortableTh label="Calls" colKey="calls" toggle={toggle} indicator={indicator} />
            <SortableTh label="Voice" colKey="fingerprints" toggle={toggle} indicator={indicator} />
            <SortableTh label="Spelling" colKey="spelling_unverified" toggle={toggle} indicator={indicator} align="left" />
          </tr>
        </thead>
        <tbody>
          {sorted.map(r => (
            <tr key={r.key} onClick={() => onOpen && onOpen(r.key)} className="cursor-pointer border-t border-gray-100 hover:bg-brand-gold/10 dark:border-gray-800">
              <td className="py-2 pr-3 font-medium whitespace-nowrap">{r.name}</td>
              <td className="py-2 pr-3">{r.role_hint}</td>
              <td className="py-2 pr-3">{r.firm || '—'}</td>
              <td className="py-2 pr-3 text-xs text-gray-500">{(r.affiliations || []).map(a => `${a.org}${a.from ? ` ${a.from.slice(0, 7)}` : ''}${a.to && a.to !== a.from ? `→${a.to.slice(0, 7)}` : ''}`).join(' · ') || '—'}</td>
              <td className="py-2 pr-3 text-xs text-gray-500">{(r.aliases || []).join(', ') || '—'}</td>
              <td className="py-2 pr-3 text-right tabular-nums">{r.calls}</td>
              <td className="py-2 pr-3 text-right tabular-nums">{r.fingerprints}</td>
              <td className={'py-2 pr-3 ' + (r.spelling_unverified ? 'text-amber-500' : 'text-green-500')}>{r.spelling_unverified ? 'unverified' : 'ok'}</td>
            </tr>))}
        </tbody>
      </table>
    </div>
  );
}
